import dynamic from 'next/dynamic';
import css from './index.module.scss';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';
import { useGlobal } from '@/utils/useGlobal';

const Content = dynamic(() => import('./dynamicContent'), {
    ssr: true,
});

export default function SolarPanel() {
    const { useLang } = useGlobal();
    const { t } = useLang('220wbifacialsolarpanel');
    const languageT = (value: string) => t(`solarpanels_220w.${value}`);
    const bannerData = [
        {
            bgImgs: '/img/productDetails/solarpanel_220w/KV-220W.png',
            title: languageT('title'),
            des: languageT('des'),
        },
    ];
    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <div style={{ width: '100%', marginTop: '-64px' }}>
                <BannerModule data={bannerData} config={{ isShowLogo: false }} />
            </div>
            <Content />
        </div>
    );
}
